import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { setMapTooltipIsVisible } from "../../../stateManagement/reducers/MapTooltipSlice";
import { getBasicObjectTypeLayer, getAllObjectsLayer } from "../../../widgets/map/mapFeatures/layers";
import { copyInfoFromTooltip, showMapTooltip } from "../../../widgets/map/mapFeatures/mapFunctions/showMapTooltip/showMapTooltip";
import MapWidget from "../../../widgets/map/mapWidget/MapWidget";
import { MapDataTable } from "../../../widgets/map/mapAddons/mapDataTable";
import { MapOverlayWidget } from "../../../widgets/map/mapAddons/mapOverlayWidget";
import { MapTooltip } from "../../../widgets/map/mapAddons/mapTooltip";
import { roadBedFiltersOptions } from "../../../widgets/map/mapAddons/mapOverlayWidget/roadBedLayerSegmentsOverlay";
import { mapLayersDict } from "../mapLayersDict";
import { setHighContrastModeIsEnabled } from "../../../stateManagement/reducers/ContentHeaderSlice";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";

export function MapRoadBedLayerSegments() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const objectTypeName = "RoadBedLayerSegments"
    const [mapTitle, setMapTitle] = useState<string>('');
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const { wmsServer, wmsVersion, workspace } = getItemWebStorage('currentConfig')
    const chosenRoadBedTypeIds = useAppSelector(state => state.roadBedLayerSegments.chosenRoadBedTypeIds)
    const tableUnderMapIsShown = useAppSelector(state => state.contentHeader.tableUnderMapIsShown)

    // определение неизменяемых слоев карты
    const roadsLayer = getAllObjectsLayer()
    const [permanentLayers] = useState([roadsLayer])

    useEffect(() => {
        const { mapLayer, caption } = mapLayersDict[objectTypeName] ?? {}
        caption && setMapTitle(`Карта «${caption}»`)
        if (!mapLayer) {
            navigate('/app/error')
        }
        let roadBedFiltersTempArray = Object.entries(chosenRoadBedTypeIds).filter(([key, value]: any) => value === true).map(([key, value]) => key)
        let roadBedFiltersArray = roadBedFiltersTempArray.map(key => roadBedFiltersOptions[key].roadbedTypeId)
        const layerFilter = `RoadbedTypeID in (${roadBedFiltersArray.join(',')})`
        const objectTypeLayer = getBasicObjectTypeLayer(mapLayer, wmsServer, wmsVersion, workspace, layerFilter)
        setAdditionalLayers([objectTypeLayer])
        dispatch(setHighContrastModeIsEnabled(true))
        return () => {
            dispatch(setHighContrastModeIsEnabled(false))
        }
    }, [objectTypeName, chosenRoadBedTypeIds]);

    function applyMapTooltip(map: any) {
        const pointerMoveFunc = (event: any) => showMapTooltip(event, 'roadBedLayerSegments', additionalLayers[0], map)
        const activeTooltipClick = (event: any) => copyInfoFromTooltip()
        map?.on("pointermove", pointerMoveFunc)
        map?.on("singleclick", activeTooltipClick)
        return {
            off: () => {
                map?.un("pointermove", pointerMoveFunc)
                map?.un("singleclick", activeTooltipClick)
                dispatch(setMapTooltipIsVisible(false))
            }
        }
    }

    const mapEventHandlers = [
        {
            name: "mapTooltip",
            func: applyMapTooltip
        }
    ]

    return (
        <>
            <ContentHeader title={mapTitle} objectTypeName={objectTypeName} type="map" />
            <div className="map-widget-with-toast">
                <MapTooltip type={objectTypeName} />
                <MapWidget additionalLayers={additionalLayers} permanentLayers={permanentLayers} mapEventHandlers={mapEventHandlers} mapSizeClass={tableUnderMapIsShown ? 'road-bed-layers-map-container' : null} />
                <MapOverlayWidget />
                {tableUnderMapIsShown && <MapDataTable className="road-bed-segments-under-map-table" />}
            </div>
        </>
    )
}
